import React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

import { hasOnePermission } from '../../../services/user/actions';

const Sensors: React.LazyExoticComponent<any> = React.lazy(() => import('../components/dashboard/Sensors'));

export default class Loader extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    // const access = hasOnePermission(['thralarms_ro', 'thralarms_rw']);
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: String(tabId || window.getStr()),
        active: true,
        title: 'Sensors | Sensors',
        component: Sensors,
        props: {
          report: 'SENSORS_SENSORS',
          title: 'Sensors',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
